import { CustomAttributes } from "@lib/enums/ProductAttributes";
import { getProductAttributeValue } from "@lib/utils/attributesUtils";
import { Text } from "@ui/components/content/text/Text";
import { Money } from "@ui/components/data-display/money/Money";
import type { SimpleMoneyData } from "@ui/components/data-display/money/useMoney";
import { Box } from "@ui/components/layout/box/Box";
import { Flex } from "@ui/components/layout/flex/Flex";
import { Grid } from "@ui/components/layout/grid/Grid";
import { NextImage } from "@ui/components/media-and-icons/image/NextImage";
import { isEmpty } from "lodash-es";
import { useLocale } from "next-intl";
import { useMemo } from "react";

export const CardItem = ({ selectedProductData }: any) => {
    const { image, name, selectedVariant, descriptiveHeading } = selectedProductData;
    const locale = useLocale();
    const selectedVariantPrice = selectedVariant.price;
    const recommendedPrice = useMemo(
        () =>
            getProductAttributeValue(
                selectedVariantPrice?.custom?.customFieldsRaw,
                CustomAttributes.RECOMMENDED_PRICE
            ),
        [selectedVariantPrice]
    );

    return (
        <Grid templateColumns={"1fr 3fr"} gap={2}>
            <Box backgroundColor={"gray.50"}>
                <NextImage
                    sx={{ aspectRatio: ["4/5"] }}
                    src={image?.url ?? ""}
                    sizes={["50vw"]}
                    alt={name}
                />
            </Box>
            <Flex flexDirection={"column"} justifyContent="space-between" gap={4}>
                <Box>
                    <Text mb={1} fontWeight={"bold"} color="black">
                        {name}
                    </Text>
                    {!isEmpty(descriptiveHeading) && (
                        <Text color="gray.500" fontWeight={"bold"}>
                            {descriptiveHeading}
                        </Text>
                    )}
                </Box>
                {!isEmpty(recommendedPrice) && recommendedPrice ? (
                    <Flex gap={1}>
                        <Money
                            fontWeight="bold"
                            locale={locale}
                            data={selectedVariantPrice.value}
                        />
                        <Money
                            fontWeight="bold"
                            color="darkGrey"
                            textDecoration="line-through"
                            locale={locale}
                            data={recommendedPrice as unknown as SimpleMoneyData}
                        />
                    </Flex>
                ) : (
                    <Flex gap={1}>
                        <Money
                            fontWeight="bold"
                            locale={locale}
                            data={selectedVariantPrice.value}
                        />
                    </Flex>
                )}
            </Flex>
        </Grid>
    );
};
